export default __webpack_public_path__ + "static/media/MASCHIO_ICONA.7d632659.svg";